import React, { Component } from 'react';
import { isEmpty } from 'lodash/fp';
import { ImagePreviewModal } from 'components/shared/ImagePreview';
import Table from 'components/shared/table';
import DeleteImageModal from 'components/ImageLibrary/DeleteImageModal';
import { Icon } from 'ui';
import { BlankSlate, Description } from 'components/_shared/blank_slate';
import noResultsSrc from 'images/content_no_results.svg';
import { routes } from 'constants/config';
import LoadableState from 'components/shared/loadable';
import { ImageTypes } from 'constants/imageTypes';
import fileStackImageUpload from 'misc/imageUpload';
import request from 'utils/request_ajax';
import DataProvider from './DataProvider';
import Image from './Image';

/* eslint no-alert: 0 */

class ImageLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: null,
      deleteConfirmModalVisible: false,
      error: null,
      isRemoving: false,
    };
    this.replaceImage = this.replaceImage.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.handlePreviewClose = this.handlePreviewClose.bind(this);
    this.toggleDeleteConfirm = this.toggleDeleteConfirm.bind(this);
    this.removeFromLibrary = this.removeFromLibrary.bind(this);
  }

  static createImage() {
    return fileStackImageUpload.withoutAssociation();
  }

  replaceImage(oldImage, reload) {
    fileStackImageUpload.updateImage(oldImage).then(image => {
      this.setState({ selectedImage: image }, reload);
    });
  }

  handleImageClick(image) {
    this.setState({ selectedImage: image });
  }

  handlePreviewClose() {
    this.setState({ selectedImage: null });
  }

  toggleDeleteConfirm() {
    this.setState(state => ({
      deleteConfirmModalVisible: !state.deleteConfirmModalVisible,
    }));
  }

  removeFromLibrary(deleteImageType, reloadOnDelete) {
    this.setState({ error: null, isRemoving: true });

    if (deleteImageType === 'instances') {
      request
        .delete(routes.IMAGES_DESTROY_ALL, { id: this.state.selectedImage.id })
        .then(() =>
          this.setState(
            { selectedImage: null, isRemoving: false },
            reloadOnDelete,
          ),
        )
        .then(this.toggleDeleteConfirm)
        .catch(e => {
          console.error(e);
          this.setState({ error: e, isRemoving: false });
        });
    }
    if (deleteImageType === 'library') {
      request
        .put(
          routes.IMAGE_LIBRARY_VISIBILITY_REMOVE(this.state.selectedImage.id),
        )
        .then(() => {
          this.setState({ isRemoving: false }, reloadOnDelete);
        })
        .then(this.toggleDeleteConfirm)
        .then(this.handlePreviewClose())
        .catch(e => {
          console.error(e);
          this.setState({ error: e, isRemoving: false });
        });
    }
  }

  render() {
    return (
      <DataProvider>
        {({
          firstPage,
          images,
          loading,
          paginationProps,
          reload,
          reloadOnDelete,
          totalImages,
          updateQuery,
          query,
        }) => (
          <div>
            {this.state.selectedImage && (
              <ImagePreviewModal
                image={this.state.selectedImage}
                imageType={ImageTypes.COVER_IMAGE_TYPE}
                onDismiss={this.handlePreviewClose}
                onDelete={this.toggleDeleteConfirm}
                onReplace={image => this.replaceImage(image, reload)}
                readonly={false}
              />
            )}
            <DeleteImageModal
              shown={this.state.deleteConfirmModalVisible}
              toggleModal={this.toggleDeleteConfirm}
              onDelete={deleteImageType =>
                this.removeFromLibrary(deleteImageType, reloadOnDelete)
              }
              error={this.state.error}
              isRemoving={this.state.isRemoving}
            />
            <div className="Index-header">
              <h1 className="Index-title">{t('image_library.title')}</h1>
              <div className="Index-newButtonsContainer">
                <button
                  type="button"
                  onClick={() => ImageLibrary.createImage().then(firstPage)}
                  className="NewButton NewButton--white"
                >
                  <Icon name="add" className="mr-4" />
                  {I18n.t('image_library.upload_new')}
                </button>
              </div>
            </div>
            <Table className="mb-32">
              <Table.Header className="px-24 py-16 d-f ai-c jc-sb">
                {loading && !totalImages ? (
                  <div>{I18n.t('common.loading')}</div>
                ) : (
                  <div>
                    <span>
                      {I18n.t('image_library.image_count', {
                        count: totalImages,
                      })}
                    </span>
                  </div>
                )}
                <input
                  placeholder={t('image_library.search_by_name')}
                  onChange={e => updateQuery(e.target.value)}
                  className="NewInput NewInput--white"
                  type="search"
                />
              </Table.Header>
              <Table.Body className="ImagesGrid p-16 bg-white">
                <LoadableState loading={loading}>
                  {!isEmpty(images) &&
                    images.map(image => (
                      <Image
                        key={image.id}
                        image={image}
                        onClick={this.handleImageClick}
                      />
                    ))}
                  {isEmpty(images) && !!query && (
                    <BlankSlate>
                      <img
                        className="mw-300 mb-32"
                        src={noResultsSrc}
                        alt={t('image_library.no_results')}
                      />
                      <Description>{t('image_library.no_results')}</Description>
                    </BlankSlate>
                  )}
                </LoadableState>
              </Table.Body>
              {paginationProps.pageCount > 1 && (
                <Table.Footer>
                  <Table.Pagination scrollTopOnChange {...paginationProps} />
                </Table.Footer>
              )}
            </Table>
          </div>
        )}
      </DataProvider>
    );
  }
}

export default ImageLibrary;
